var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-tag',{attrs:{"size":"mini","type":_vm.processTypeClass}},[_c('i',{class:['fas', _vm.processTypeIcon]}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.processTypeLabel))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-49a13888","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/doc-in/vb-process-type-tag.vue
// module id = null
// module chunks = 